// @flow
import margin from '../margin'
import padding from '../padding'
import type { SpacingSize } from '../constants/spacing'

const REG = /^[mp][trblxy]?$/

const properties = {
  m: margin,
  p: padding,
}

const directions = {
  t: 'top',
  r: 'right',
  b: 'bottom',
  l: 'left',
  x: 'x',
  y: 'y',
}

const getProperty = key => {
  const [a, b] = key.split('')
  const prop = properties[a]
  const dir = directions[b]
  return dir ? prop[dir] : prop
}

export type SpaceProps = {
  m?: SpacingSize,
  mt?: SpacingSize,
  mr?: SpacingSize,
  mb?: SpacingSize,
  ml?: SpacingSize,
  mx?: SpacingSize | 'auto',
  my?: SpacingSize | 'auto',
  px?: SpacingSize,
  py?: SpacingSize,
}

const space = (props: SpaceProps) => {
  const keys = Object.keys(props)
    .filter(key => REG.test(key))
    .sort()

  return keys.map(key => {
    // eslint-disable-next-line react/destructuring-assignment
    const value = props[key]
    const property = getProperty(key)
    return property(value)
  })
}

export default space



// WEBPACK FOOTER //
// ./src/style/props/space.js